import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
import { useMergedState } from '../_utils/hooks';
// type SwitchSize = 'large' | 'middle' | 'small'
export var SwitchSizes = tuple('large', 'small');
var Switch = function Switch(props) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var switchProps = getCompProps('Switch', userDefaultProps, props);
  var size = switchProps.size,
    className = switchProps.className,
    customPrefixcls = switchProps.prefixCls,
    checked = switchProps.checked,
    defaultChecked = switchProps.defaultChecked,
    checkedChildren = switchProps.checkedChildren,
    unCheckedChildren = switchProps.unCheckedChildren,
    loading = switchProps.loading,
    disabled = switchProps.disabled,
    onClick = switchProps.onClick,
    onChange = switchProps.onChange,
    others = __rest(switchProps, ["size", "className", "prefixCls", "checked", "defaultChecked", "checkedChildren", "unCheckedChildren", "loading", "disabled", "onClick", "onChange"]);
  var _useMergedState = useMergedState(false, {
      value: checked,
      defaultValue: defaultChecked
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    newChecked = _useMergedState2[0],
    setChecked = _useMergedState2[1];
  var switchPrefixCls = getPrefixCls(prefixCls, 'switch', customPrefixcls);
  var handleClick = function handleClick(e) {
    var newV = triggerChange(!newChecked, e);
    onClick && onClick(newV, e);
  };
  function triggerChange(newV, e) {
    var isDisabled = disabled || loading;
    var afterChangedChecked = newChecked;
    if (!isDisabled) {
      afterChangedChecked = newV;
      setChecked(afterChangedChecked);
      onChange === null || onChange === void 0 ? void 0 : onChange(afterChangedChecked, e);
    }
    return afterChangedChecked;
  }
  // ref
  var switchClasses = classNames(switchPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(switchPrefixCls, "-size-")).call(_context, size), size), _defineProperty(_classNames, "".concat(switchPrefixCls, "-disabled"), disabled || loading), _defineProperty(_classNames, "".concat(switchPrefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(switchPrefixCls, "-checked"), newChecked), _classNames));
  var loadingIcon = loading ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(switchPrefixCls, "-loading-icon")
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "loadding-circle",
    spin: true
  })) : null;
  return /*#__PURE__*/React.createElement("span", _extends({
    className: switchClasses
  }, others, {
    onClick: handleClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(switchPrefixCls, "-inner")
  }, loadingIcon, newChecked ? checkedChildren : unCheckedChildren));
};
Switch.displayName = 'Switch';
export default Switch;